<script setup>
defineProps({
  label: {
    type: String,
    default: 'Loading',
  },
})
</script>

<template>
  <span class="loading-animation" :aria-label="label">
    <span />
    <span />
    <span />
  </span>
</template>

<style scoped>
.loading-animation {
  display: inline-flex;
  align-items: flex-end;
  gap: 4px;
  height: 1em;
  vertical-align: baseline;
}

.loading-animation span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #4b5563;
  animation: loading-dot-bump 0.9s infinite ease-in-out;
}

.loading-animation span:nth-child(2) {
  animation-delay: 0.12s;
}

.loading-animation span:nth-child(3) {
  animation-delay: 0.24s;
}

@keyframes loading-dot-bump {
  0%,
  80%,
  100% {
    transform: translateY(0);
    opacity: 0.45;
  }

  40% {
    transform: translateY(-5px);
    opacity: 1;
  }
}
</style>
